import { BounceButton } from '../../../Shared';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ButtonProps } from '@mui/material';

interface NavButtonProps extends ButtonProps {}
export const NextButton = ({
  onClick = () => {},
  disabled = false,
  type = 'button',
  children = 'Next',
  ...rest
}: NavButtonProps) => (
  <BounceButton
    type={type}
    onClick={onClick}
    disabled={disabled}
    variant='contained'
    color='primary'
    size='medium'
    endIcon={<ChevronRightIcon />}
    {...rest}
  >
    {children}
  </BounceButton>
);

export const BackButton = ({
  onClick = () => {},
  disabled = false,
  type = 'button',
  children = 'Back',
  ...rest
}: NavButtonProps) => (
  <BounceButton
    type={type}
    onClick={onClick}
    disabled={disabled}
    variant='outlined'
    color='primary'
    size='medium'
    startIcon={<ChevronLeftIcon />}
    {...rest}
  >
    {children}
  </BounceButton>
);
